<div
  class="flex items-start gap-3 p-4 rounded-lg border border-amber-200/90 dark:border-amber-800/60 bg-amber-50 dark:bg-amber-950/40 border-l-8 border-l-amber-500 dark:border-l-amber-600"
  role="status"
  aria-live="polite"
>
  <lucide-icon
    name="arrow-left-right"
    class="w-6 h-6 flex-shrink-0 mt-0.5 text-amber-800 dark:text-amber-300"
    aria-hidden="true"
  ></lucide-icon>
  <div class="flex-1 min-w-0 space-y-2">
    <p class="text-sm font-bold text-amber-950 dark:text-amber-100 leading-snug">
      Selecione um contexto para começar.
    </p>
    <p class="text-sm leading-relaxed text-amber-900/95 dark:text-amber-200/95">
      Para visualizar as informações, clique no botão &quot;Escolher contexto&quot; e selecione o contexto desejado. Caso não tenha opções disponíveis ou tenha dúvidas, entre em contato com a secretaria escolar.
    </p>
  </div>
</div>
